import axios from "axios";
import store from './../index'

// После переноса/копирования позиций в хранилище ничего не дописываем в стор руками:
// у товара, который уже лежал в хранилище, количество на бэке суммируется (ключ хранилище+товар+пользователь),
// и локальный push дал бы дубль строки. Хранилище перечитываем, только если открыто именно оно
// (иначе подменили бы список другого хранилища); список заказов — всегда.
async function refreshAfterStorageChange(toStorageId, ordersChanged) {
    if (store.getters.CURRENT_STORAGE_ID == toStorageId) {
        await store.dispatch('STORAGE_GOODS', toStorageId);
    }
    if (ordersChanged) {
        await store.dispatch('REFRESH_ORDERS');
    }
}

export default {
    state: {
        accessStorages: [],
        storageGoods: [],
        // id хранилища, чьи позиции сейчас лежат в storageGoods
        currentStorageId: null,
        deleteStorageGoodsStatus: null,
        dialog: false,
        goodsId: 0
    },
    getters: {
        ACCESS_STORAGES: state => {
            return state.accessStorages;
        },
        STORAGE_GOODS: state => {
            return state.storageGoods;
        },
        CURRENT_STORAGE_ID: state => {
            return state.currentStorageId;
        },
        DELETE_STORAGE_GOODS_STATUS: state => {
            return state.deleteStorageGoodsStatus;
        },
        STORAGE_DIALOG: state => {
            return state.dialog;
        },
        STORAGE_GOODS_ID: state => {
            return state.goodsId
        }
    },
    mutations: {
        SET_ACCESS_STORAGES: (state, payload) => {
            state.accessStorages = payload;
        },
        SET_STORAGE_GOODS: (state, payload) => {
            state.storageGoods = payload;
        },
        SET_CURRENT_STORAGE_ID: (state, payload) => {
            state.currentStorageId = payload;
        },
        SET_NEW_STORAGE: (state, payload) => {
            state.accessStorages.push(payload);
        },
        SET_DELETE_STORAGE: (state, payload) => {
            state.accessStorages = state.accessStorages.filter(
                x => x.storage.id != payload
            );
        },
        SET_NEW_STORAGE_SINGLE_GOODS: (state, payload) => {
            state.storageGoods.push(payload);
        },
        SET_NEW_STORAGE_MULTIPLE_GOODS: (state, payload) => {
            state.storageGoods.push(...payload);
        },
        SET_DELETE_STORAGE_GOODS_STATUS: (state, payload) => {
            state.deleteStorageGoodsStatus = payload;
        },
        SET_REMOVE_STORAGE_GOODS: (state, payload) => {
            const goodsIdsToDelete = [];

            payload.items.forEach(({ goodsId, quantity }) => {
                const existing = state.storageGoods.find(
                    x => x.storageId == payload.storageId && x.goodsId == goodsId
                );

                if (!existing) return;

                if (existing.quantity > quantity) {
                    existing.quantity -= quantity;
                } else {
                    goodsIdsToDelete.push(goodsId);
                }
            });

            if (goodsIdsToDelete.length > 0) {
                state.storageGoods = state.storageGoods.filter(
                    x => !(x.storageId == payload.storageId && goodsIdsToDelete.includes(x.goodsId))
                );
            }
        },
        SET_STORAGE_DIALOG: (state, payload) => {
            state.dialog = payload;
        },
        SET_STORAGE_GOODS_ID: (state, payload) => {
            state.goodsId = payload;
        }
    },
    actions: {
        ACCESS_STORAGES: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/Storage/GetAccessStoragesAsync`, payload)
                    .then(({
                        data,
                        status
                    }) => {
                        if (status === 200) {
                            store.commit('SET_ACCESS_STORAGES', data);
                            resolve(true);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        ACCESS_STORAGES_BY_ORDER_ID: async (_, orderId) => {
            const { data } = await axios.get(
                `/Storage/GetAccessStoragesByOrderIdAsync?orderId=${orderId}`
            );
            return data;
            },

        STORAGE_GOODS: async ({ commit }, storageId) => {
            commit('SET_CURRENT_STORAGE_ID', storageId);
            const { data } = await axios.get(
                `/Storage/GetStorageGoodsByIdAsync?storageId=${storageId}`
            );

            commit('SET_STORAGE_GOODS', data);
        },

        CREATE_STORAGE: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/Storage/Create`, payload)
                    .then(({
                        data,
                        status
                    }) => {

                        if (status === 200) {
                            payload.id = data
                            store.commit('SET_NEW_STORAGE', {
                                storage: payload
                            });
                            let Success = {
                                text: 'Создано хранилище с именем ' + payload.name,
                                timeout: 5000,
                                color: 'success',
                                show: true
                            }
                            store.commit('SET_SNACKBAR', Success);
                            resolve(true);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },

        DELETE_STORAGE: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/Storage/DeleteById?id=` + payload)
                    .then(({
                        status
                    }) => {
                        if (status === 200) {
                            store.commit('SET_DELETE_STORAGE', payload);
                            resolve(true);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },

        CREATE_STORAGE_GOODS: async ({ dispatch }, payload) => {
            await axios.post(
                `/Storage/CreateStorageGoodsAsync`,
                payload
            );

            await dispatch('STORAGE_GOODS', payload.storageId);
        },

        DELETE_STORAGE_GOODS: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/Storage/DeleteStorageGoodsAsync`, {data : payload})
                    .then(({
                        status
                    }) => {
                        if (status === 200) {
                            store.commit('SET_DELETE_STORAGE_GOODS_STATUS', true);
                        }
                        else{
                            store.commit('SET_DELETE_STORAGE_GOODS_STATUS', false);
                        }
                        resolve(true);
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
        ACCESS_USERS_BY_STORAGE_ID: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/Storage/GetAccessUsersByStorageIdAsync?storageId=` + payload)
                    .then(({
                        data,
                        status
                    }) => {

                        if (status === 200) {
                            resolve(data);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
        CREATE_ACCESS_USERS_STORAGE: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/Storage/CreateAccessUsersStorageAsync`, payload)
                    .then(({
                        data,
                        status
                    }) => {

                        if (status === 200) {
                            store.commit('SET_NEW_STORAGE_SINGLE_GOODS', data);
                            let Success = {
                                text: 'Доступ предоставлен',
                                timeout: 5000,
                                color: 'success',
                                show:true
                                
                            }
                            store.commit('SET_SNACKBAR', Success);
                            resolve(true);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
        MOVE_DETAILS_TO_STORAGE: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/Storage/MoveDetails?toStorageId=` + payload.toStorageId,
                        payload.details.map(x => x.id),
                    )
                    .then(async ({
                        status
                    }) => {
                        if (status === 200) {
                            await refreshAfterStorageChange(payload.toStorageId, true);
                            resolve(true);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
        MOVE_DETAILS_TO_STORAGE_BY_ORDER: (_, payload) => {
            return new Promise((resolve, reject) => {
                axios
                .put(
                    `/Storage/MoveDetailsByOrderAsync?toStorageId=${payload.toStorageId}&orderId=${payload.orderId}`,
                    payload.details.map((x) => x.id)
                )
                .then(async ({ status }) => {
                    if (status === 200) {
                        await refreshAfterStorageChange(payload.toStorageId, true);
                        resolve(true);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
            });
            },
        // Excel хранилища (Id / Название / Кол-во) в формате выгрузки заказов; файл приходит blob'ом, имя — из content-disposition
        DOWNLOAD_STORAGE_EXCEL: async (commit, storageId) => {
            const response = await axios.get("/Storage/GetStorageGoodsInExcel", {
                params: { storageId },
                responseType: "blob"
            });

            let filename = `PH_storage_${storageId}.xlsx`;
            const disposition = response.headers["content-disposition"];
            if (disposition) {
                const matchNew = disposition.match(/filename\*=UTF-8''([^;]+)/);
                const matchOld = disposition.match(/filename="?(.+?)"?(;|$)/);
                if (matchNew?.[1]) {
                    filename = decodeURIComponent(matchNew[1]);
                } else if (matchOld?.[1]) {
                    filename = matchOld[1];
                }
            }

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(link.href);
        },
        COPY_DETAILS_TO_STORAGE: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/Storage/CopyDetails?toStorageId=` + payload.toStorageId,
                        payload.details.map(x => x.id),
                    )
                    .then(async ({
                        status
                    }) => {
                        if (status === 200) {
                            await refreshAfterStorageChange(payload.toStorageId, false);
                            resolve(true);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
    }
};